import { useQuery } from '@tanstack/react-query';
import useApi from 'infrastructure/api/useApi';
import { adsAnalyticsAccessEndpoint } from 'infrastructure/api/endpoints';
import useCurrentUser from 'infrastructure/currentUser/useCurrentUser';
import { canReadAdsAnalyticsAccess } from 'infrastructure/currentUser/cmsRoleAccess';
import shouldRetryApiQuery from 'infrastructure/api/shouldRetryApiQuery';

const useAdsAnalyticsAccess = () => {
  const { requestApi } = useApi();
  const { currentUser, hasAnalyticsViewerPermissions } = useCurrentUser();
  const canRequestAdsAnalyticsAccess = canReadAdsAnalyticsAccess(currentUser);
  const accessQuery = useQuery<{ canAccess: boolean }>({
    enabled: canRequestAdsAnalyticsAccess,
    queryKey: ['analytics', 'adsAccess'],
    queryFn: () =>
      requestApi(adsAnalyticsAccessEndpoint, { method: 'GET' }).then(
        ({ data }) => data
      ),
    retry: shouldRetryApiQuery,
  });

  return {
    canAccess:
      canRequestAdsAnalyticsAccess &&
      (accessQuery.data?.canAccess === true ||
        (accessQuery.isError && hasAnalyticsViewerPermissions === false)),
    isLoading: canRequestAdsAnalyticsAccess && accessQuery.isLoading,
  };
};

export default useAdsAnalyticsAccess;
